import { State } from "../types/store";

export const selectUIUserOptions = (state: State) => state.ui.userOptions;
